
/**
 * SpacingStylesProcessor - Creates styles for spacing and layout utilities
 */
export class SpacingStylesProcessor {
  static createSpacingStyles(): string {
    return `
      /* Common spacing */
      .onexip-calculator-container .space-y-4 > * + * {
        margin-top: 1rem !important;
      }

      .onexip-calculator-container .space-y-6 > * + * {
        margin-top: 1.5rem !important;
      }

      /* Flex utilities */
      .onexip-calculator-container .flex {
        display: flex !important;
      }

      .onexip-calculator-container .justify-between {
        justify-content: space-between !important;
      }

      .onexip-calculator-container .items-center {
        align-items: center !important;
      }

      .onexip-calculator-container .gap-2 {
        gap: 0.5rem !important;
      }

      .onexip-calculator-container .gap-4 {
        gap: 1rem !important;
      }
    `;
  }
}
